import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { AvailabilityLocationType, } from '@wix/ambassador-availability-calendar/types';
import { DailyTimetableSettingsKeys, } from '@wix/bookings-app-builder-settings-const/dist/src/DailyTimeTable/Settings.const';
import { navigateToBookingsFormPage } from '@wix/bookings-booking-navigation';
import { navigateToBookingsServicePage } from '@wix/bookings-catalog-calendar-viewer-navigation';
import { isBookingFormInstalled, isTemplateMode, openPreviewPremiumModal, openUoUPremiumModal, openWaitingListModal, } from '@wix/bookings-catalog-calendar-viewer-utils';
import { DateTimeFormatter } from '@wix/bookings-date-time';
import { ServiceLocationType, ServiceType, } from '@wix/bookings-uou-types/dist/src';
import moment from 'moment';
import format from 'string-format';
import { TimetableActionType, WidgetReferralInfo } from '../bi-logger/bi.const';
import { getFlowApiEnvironment } from '../utils/getFlowApiEnvironment';
export var SlotRepeaterState;
(function (SlotRepeaterState) {
    SlotRepeaterState["LOADING"] = "loaderState";
    SlotRepeaterState["LIST"] = "slotRepeaterState";
    SlotRepeaterState["NO_CLASSES"] = "noClassesState";
})(SlotRepeaterState || (SlotRepeaterState = {}));
var createDummySlotsAvailability = function (translations) { return [
    createDummySlotAvailability({
        translations: translations,
        index: 0,
        availableSpots: 16,
    }),
    createDummySlotAvailability({
        translations: translations,
        index: 1,
        availableSpots: 10,
    }),
    createDummySlotAvailability({
        translations: translations,
        index: 2,
        availableSpots: 12,
    }),
]; };
var createDummyServices = function (translations) {
    return [
        createDummyService(translations, 0),
        createDummyService(translations, 1),
        createDummyService(translations, 2),
    ];
};
var createDummyService = function (translations, index) {
    return {
        id: "dummy-service-id-".concat(index + 1),
        info: {
            name: translations["bookings.daily-timetable.dummy.workout".concat(index + 1)],
            slugs: ["dummy-service-".concat(index + 1)],
            type: ServiceType.GROUP,
        },
    };
};
var createDummySlotAvailability = function (_a) {
    var translations = _a.translations, index = _a.index, availableSpots = _a.availableSpots;
    var start = moment()
        .add(index + 1, 'hours')
        .startOf('hour');
    var end = moment()
        .add(index + 2, 'hours')
        .startOf('hour');
    return {
        slot: {
            sessionId: "dummy-slot-id-".concat(index + 1),
            serviceId: "dummy-service-id-".concat(index + 1),
            startDate: start.format(),
            endDate: end.format(),
            scheduleId: "dummy-schedule-id-".concat(index + 1),
            resource: {
                id: "dummy-staff-id-".concat(index + 1),
                name: translations["bookings.daily-timetable.dummy.name".concat(index + 1)],
            },
        },
        openSpots: availableSpots,
        bookingPolicyViolations: {
            tooEarlyToBook: false,
            tooLateToBook: false,
            bookOnlineDisabled: false,
        },
        bookable: true,
    };
};
var SlotsListViewModel = /** @class */ (function () {
    function SlotsListViewModel(_a) {
        var $widget = _a.$widget, $w = _a.$w, biLogger = _a.biLogger, bookingsApi = _a.bookingsApi, timetableSettings = _a.timetableSettings, catalogData = _a.catalogData, bookingEntries = _a.bookingEntries, translations = _a.translations, wixCodeApi = _a.wixCodeApi, appParams = _a.appParams, platformAPIs = _a.platformAPIs, languageState = _a.languageState;
        var _this = this;
        this.isRtl = false;
        this.isMobile = false;
        this.isLoading = false;
        this.isAnimating = false;
        this.translations = {};
        this.timezone = 'UTC';
        this.isRendered = false;
        this.shouldDisplaySlotLocations = false;
        this.isDummy = false;
        this.animateLoader = function () {
            var duration = 400;
            var delay = 100;
            return Promise.all([
                _this.$w('#vectorImage3')
                    .show('zoom', { duration: duration, delay: 3 * delay })
                    .then(function () { return _this.$w('#vectorImage3').hide('zoom', { duration: duration }); }),
                _this.$w('#vectorImage2')
                    .show('zoom', { duration: duration, delay: 2 * delay })
                    .then(function () { return _this.$w('#vectorImage2').hide('zoom', { duration: duration }); }),
                _this.$w('#vectorImage1')
                    .show('zoom', { duration: duration, delay: delay })
                    .then(function () { return _this.$w('#vectorImage1').hide('zoom', { duration: duration }); }),
            ]);
        };
        this.wixCodeApi = wixCodeApi;
        this.appParams = appParams;
        this.environment = getFlowApiEnvironment(wixCodeApi);
        this.$w = $w;
        this.$widget = $widget;
        this.languageState = languageState;
        this.translations = translations;
        this.bookingsApi = bookingsApi;
        this.isMobile =
            this.wixCodeApi.window.formFactor === 'Mobile';
        this.isRtl = this.languageState.isViewDirectionRtl();
        this.biLogger = biLogger;
        this.settings = timetableSettings;
        this.catalogData = catalogData;
        this.bookingEntries = bookingEntries;
        this.setupReadyListeners();
        this.dateTimeFormatter = new DateTimeFormatter(this.catalogData.businessInfo.dateRegionalSettingsLocale);
        if (this.environment.isEditorMode) {
            this.dummyServices = createDummyServices(this.translations);
        }
        this.shouldDisplaySlotLocations = this.hasMultipleBusinessLocations();
        this.wixCodeApi = wixCodeApi;
        this.platformAPIs = platformAPIs;
    }
    SlotsListViewModel.prototype.hasMultipleBusinessLocations = function () {
        var businessLocationsIds = this.catalogData.services
            .flatMap(function (service) { return service === null || service === void 0 ? void 0 : service.locations; })
            .filter(function (location) { return location.type === ServiceLocationType.OWNER_BUSINESS; })
            .map(function (location) { var _a; return (_a = location === null || location === void 0 ? void 0 : location.businessLocation) === null || _a === void 0 ? void 0 : _a.id; });
        var businessLocationsIdsWithoutDuplications = new Set(businessLocationsIds);
        return businessLocationsIdsWithoutDuplications.size > 1;
    };
    SlotsListViewModel.prototype.setLoading = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.switchState(SlotRepeaterState.LOADING)];
                    case 1:
                        _a.sent();
                        this.startAnimation();
                        return [2 /*return*/, this.startLoaderAnimation()];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setListLoaded = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = false;
                        this.stopAnimation();
                        return [4 /*yield*/, this.switchState(SlotRepeaterState.LIST)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setNoClassesState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = false;
                        this.stopAnimation();
                        return [4 /*yield*/, this.switchState(SlotRepeaterState.NO_CLASSES)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setSlots = function (slots, isInitialLoad) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.slotsRepeater.data = slots
                            .sort(function (slot1, slot2) {
                            return +new Date(slot1.slot.endDate) - +new Date(slot2.slot.startDate);
                        })
                            .map(function (slot, index) { return (__assign(__assign({}, slot), { _id: slot.slot.sessionId, isFocused: !isInitialLoad && index === 0 })); });
                        return [4 /*yield*/, this.setListLoaded()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setCleanMode = function () {
        this.slotsRepeater.data = [];
    };
    SlotsListViewModel.prototype.setSlotsList = function (slots, timezone, isInitialLoad) {
        if (isInitialLoad === void 0) { isInitialLoad = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.timezone = timezone;
                        if (!(slots && slots.length)) return [3 /*break*/, 2];
                        this.isDummy = false;
                        return [4 /*yield*/, this.setSlots(slots, isInitialLoad)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!this.environment.isEditorMode) return [3 /*break*/, 4];
                        this.isDummy = true;
                        return [4 /*yield*/, this.setSlots(createDummySlotsAvailability(this.translations), isInitialLoad)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        this.isDummy = false;
                        this.slotsRepeater.data = [];
                        return [4 /*yield*/, this.setNoClassesState()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setViewLoaded = function () {
        this.isRendered = true;
    };
    SlotsListViewModel.prototype.stopAnimation = function () {
        this.isAnimating = false;
    };
    SlotsListViewModel.prototype.startAnimation = function () {
        this.isAnimating = true;
    };
    SlotsListViewModel.prototype.isNoBookFlow = function (itemData) {
        return itemData.bookingPolicyViolations.bookOnlineDisabled;
    };
    SlotsListViewModel.prototype.isBlockedByActiveFeatures = function () {
        return !this.catalogData.activeFeatures.applicableForGroups;
    };
    SlotsListViewModel.prototype.isFull = function (itemData) {
        return itemData.openSpots === 0;
    };
    SlotsListViewModel.prototype.isWaitingListFlow = function (itemData) {
        var _a;
        return this.isFull(itemData) && ((_a = itemData.waitingList) === null || _a === void 0 ? void 0 : _a.openSpots);
    };
    SlotsListViewModel.prototype.isTooLateToBook = function (itemData) {
        return itemData.bookingPolicyViolations.tooLateToBook;
    };
    SlotsListViewModel.prototype.isBookedByMember = function (itemData) {
        return this.bookingEntries.some(function (bookingEntry) {
            var _a, _b, _c, _d, _e, _f;
            return ((_c = (_b = (_a = bookingEntry.booking) === null || _a === void 0 ? void 0 : _a.bookedEntity) === null || _b === void 0 ? void 0 : _b.singleSession) === null || _c === void 0 ? void 0 : _c.sessionId) ===
                itemData.slot.sessionId ||
                ((_f = (_e = (_d = bookingEntry.booking) === null || _d === void 0 ? void 0 : _d.bookedEntity) === null || _e === void 0 ? void 0 : _e.slot) === null || _f === void 0 ? void 0 : _f.sessionId) ===
                    itemData.slot.sessionId;
        });
    };
    SlotsListViewModel.prototype.getSlotCtaText = function (itemData) {
        if (this.isBookedByMember(itemData)) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_DISABLED_TEXT_BOOKED] ||
                this.translations['bookings.daily-timetable.cta.defaults.booked']);
        }
        if (this.isNoBookFlow(itemData)) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_ENABLED_TEXT_MORE_INFO] ||
                this.translations['bookings.daily-timetable.cta.defaults.more-info']);
        }
        if (this.isWaitingListFlow(itemData)) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_ENABLED_TEXT_WAITING_LIST] ||
                this.translations['bookings.daily-timetable.cta.defaults.waiting-list']);
        }
        if (this.isFull(itemData)) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_DISABLED_TEXT_FULL] ||
                this.translations['bookings.daily-timetable.cta.defaults.full']);
        }
        if (this.isTooLateToBook(itemData)) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_DISABLED_TEXT_CLOSED] ||
                this.translations['bookings.daily-timetable.cta.defaults.closed']);
        }
        return (this.settings[DailyTimetableSettingsKeys.BUTTON_ENABLED_TEXT_BOOK_NOW] ||
            this.translations['bookings.daily-timetable.cta.defaults.book-now']);
    };
    SlotsListViewModel.prototype.shouldDisableCta = function (itemData) {
        if (this.isWaitingListFlow(itemData) || this.isNoBookFlow(itemData)) {
            return false;
        }
        return !itemData.bookable || this.isBookedByMember(itemData);
    };
    SlotsListViewModel.prototype.navigateToSelectedSection = function (itemData, service) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var serviceId, serviceSlug, location, sendClickEventWithAction, isBookingsFormInstalled, actionName;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        serviceId = itemData.slot.serviceId;
                        serviceSlug = service.info.slugs[0];
                        location = (_b = (_a = itemData.slot) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.id;
                        sendClickEventWithAction = function (action) {
                            return _this.biLogger.sendTimeTableClickEvent({
                                serviceId: serviceId,
                                type: ServiceType.GROUP,
                                isNoBookFlow: _this.isNoBookFlow(itemData),
                                isOverEditor: _this.environment.isEditorMode,
                                isPreviewMode: _this.environment.isPreviewMode,
                                action: action,
                            });
                        };
                        if (!this.isNoBookFlow(itemData)) return [3 /*break*/, 2];
                        sendClickEventWithAction(TimetableActionType.NAVIGATE_TO_SERVICE_PAGE);
                        return [4 /*yield*/, navigateToBookingsServicePage(this.wixCodeApi, {
                                serviceSlug: serviceSlug,
                                referral: WidgetReferralInfo.TIME_TABLE,
                                location: location,
                            })];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 12];
                    case 2:
                        if (!(!isTemplateMode({
                            wixCodeApi: this.wixCodeApi,
                            appParams: this.appParams,
                        }) &&
                            this.isBlockedByActiveFeatures())) return [3 /*break*/, 7];
                        if (!this.environment.isPreviewMode) return [3 /*break*/, 4];
                        sendClickEventWithAction(TimetableActionType.OPEN_OWNER_PREMIUM_MODAL);
                        return [4 /*yield*/, openPreviewPremiumModal({
                                wixCodeApi: this.wixCodeApi,
                                appParams: this.appParams,
                                serviceType: ServiceType.GROUP,
                                referralInfo: WidgetReferralInfo.TIME_TABLE,
                            })];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        sendClickEventWithAction(TimetableActionType.OPEN_UOU_PREMIUM_MODAL);
                        void this.bookingsApi.notifyOwnerNonPremium(service);
                        void this.biLogger.sendTimetablePremiumPrevention();
                        return [4 /*yield*/, openUoUPremiumModal({
                                wixCodeApi: this.wixCodeApi,
                                appParams: this.appParams,
                                serviceType: ServiceType.GROUP,
                                referralInfo: WidgetReferralInfo.TIME_TABLE,
                            })];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6: return [3 /*break*/, 12];
                    case 7:
                        if (!this.isWaitingListFlow(itemData)) return [3 /*break*/, 9];
                        sendClickEventWithAction(TimetableActionType.OPEN_WAITING_LIST_MODAL);
                        return [4 /*yield*/, openWaitingListModal({
                                appParams: this.appParams,
                                wixCodeApi: this.wixCodeApi,
                                serviceType: ServiceType.GROUP,
                            })];
                    case 8:
                        _c.sent();
                        return [3 /*break*/, 12];
                    case 9: return [4 /*yield*/, isBookingFormInstalled(this.wixCodeApi)];
                    case 10:
                        isBookingsFormInstalled = _c.sent();
                        actionName = isBookingsFormInstalled
                            ? TimetableActionType.NAVIGATE_TO_BOOKING_FORM
                            : TimetableActionType.NAVIGATE_TO_CONTACT_FORM;
                        sendClickEventWithAction(actionName);
                        return [4 /*yield*/, navigateToBookingsFormPage({
                                wixCodeApi: this.wixCodeApi,
                                platformAPIs: this.platformAPIs,
                                slotAvailability: itemData,
                                serviceId: serviceId,
                                serviceSlug: serviceSlug,
                                queryParams: {
                                    referral: WidgetReferralInfo.TIME_TABLE,
                                },
                            })];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setupReadyListeners = function () {
        var _this = this;
        this.slotsRepeater.onItemReady(function ($item, itemData, index) {
            var _a;
            var services = _this.isDummy
                ? _this.dummyServices
                : _this.catalogData.services;
            var service = services.find(function (_a) {
                var id = _a.id;
                return id === itemData.slot.serviceId;
            });
            var serviceName = service.info.name;
            var startTime = _this.dateTimeFormatter.formatTime(itemData.slot.startDate);
            var spotsAvailable = _this.getSpotsString(itemData.openSpots);
            var staffMember = _this.getSessionInfoString(itemData.slot.resource, itemData.slot.location);
            var duration = _this.getDurationString(new Date(itemData.slot.startDate).valueOf(), new Date(itemData.slot.endDate).valueOf());
            $item('#serviceName').text = serviceName;
            $item('#time').text = startTime;
            $item('#spots').text = spotsAvailable;
            $item('#staffMember').text = staffMember;
            $item('#duration').text = duration;
            $item('#bookButton').label = _this.getSlotCtaText(itemData);
            if (_this.shouldDisableCta(itemData)) {
                $item('#bookButton').disable();
            }
            $item('#bookButton').onClick(function () {
                void _this.navigateToSelectedSection(itemData, service);
            });
            if (itemData.isFocused && $item('#bookButton').focus) {
                // todo: until thunderbolt is completely merged we need to check that focus exists
                $item('#bookButton').focus();
            }
            if ((_a = $item('#bookButton')) === null || _a === void 0 ? void 0 : _a.accessibility) {
                // todo: until thunderbolt is completely merged we need to check $item('#bookButton')?.accessibility
                $item('#bookButton').accessibility.ariaLabel = "".concat(_this.getSlotCtaText(itemData), ", ").concat(serviceName, ", ").concat(startTime, ", ").concat(spotsAvailable, ", ").concat(staffMember, ", ").concat(duration);
            }
        });
    };
    Object.defineProperty(SlotsListViewModel.prototype, "slotsRepeater", {
        get: function () {
            return this.$w('#slotRepeater');
        },
        enumerable: false,
        configurable: true
    });
    SlotsListViewModel.prototype.getSessionInfoString = function (staffMember, location) {
        var staffText = staffMember && staffMember.name;
        var locationText;
        if (this.shouldDisplaySlotLocations) {
            if (location &&
                location.locationType === AvailabilityLocationType.OWNER_CUSTOM) {
                locationText = location.formattedAddress;
            }
            else if (location && location.name) {
                locationText = location.name;
            }
        }
        var sessionInfo = __spreadArray(__spreadArray([], (staffText ? [staffText] : []), true), (locationText ? [locationText] : []), true);
        return sessionInfo.join(', ');
    };
    SlotsListViewModel.prototype.getLocalizedTimeFormatter = function (wixSdkAdapter, timezone) {
        return function (timestamp) {
            return new Date(timestamp).toLocaleTimeString(this.wixCodeApi.site.regionalSettings, {
                timeZone: timezone,
                hour: '2-digit',
                minute: '2-digit',
            });
        };
    };
    SlotsListViewModel.prototype.switchState = function (targetState) {
        return __awaiter(this, void 0, void 0, function () {
            var changeStatePromise, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        changeStatePromise = this.$w('#statebox').changeState(targetState);
                        if (!this.isRendered) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, changeStatePromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // WA for https://jira.wixpress.com/browse/WEED-20100
                        console.error('failed to change state to: ', targetState, ' caused by ', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    SlotsListViewModel.prototype.getSpotsString = function (availableSpots) {
        var formatString = this.translations[availableSpots === 0
            ? 'bookings.daily-timetable.available-spot.none'
            : availableSpots === 1
                ? 'bookings.daily-timetable.available-spot.single'
                : 'bookings.daily-timetable.available-spot.multiple'];
        return format(formatString, availableSpots);
    };
    SlotsListViewModel.prototype.getDurationString = function (start, end) {
        var _a = this.getDuration(start, end), min = _a.min, hr = _a.hr;
        var minFormatString = this.translations[min === 1
            ? 'bookings.daily-timetable.min.single'
            : 'bookings.daily-timetable.min.multiple'];
        var hrFormatString = this.translations[hr === 1
            ? 'bookings.daily-timetable.hours.single'
            : 'bookings.daily-timetable.hours.multiple'];
        return format(this.translations['bookings.daily-timetable.duration'] || '{0} {1}', hr ? format(hrFormatString, hr) : '', min || !hr ? format(minFormatString, min) : '').trim();
    };
    SlotsListViewModel.prototype.getDuration = function (start, end) {
        var durationTime = moment.duration(end - start, 'milliseconds');
        return {
            min: durationTime.minutes(),
            hr: Math.floor(durationTime.asHours()),
        };
    };
    SlotsListViewModel.prototype.getDurationStringInMinutes = function (start, end) {
        var min = this.getDurationInMin(start, end);
        var formatString = this.translations[min === 1
            ? 'bookings.daily-timetable.min.single'
            : 'bookings.daily-timetable.min.multiple'];
        return format(formatString, min);
    };
    SlotsListViewModel.prototype.getDurationInMin = function (start, end) {
        return Math.round((end - start) / 60000);
    };
    SlotsListViewModel.prototype.startLoaderAnimation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.environment.isEditorMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(this.loader.map(function (dot) { return dot.hide(); }))];
                    case 1:
                        _a.sent();
                        this.asyncInterval(this.animateLoader);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.asyncInterval = function (func) {
        var _this = this;
        func().then(function () { return _this.isLoading && _this.isAnimating && _this.asyncInterval(func); });
    };
    Object.defineProperty(SlotsListViewModel.prototype, "loader", {
        get: function () {
            return [
                this.$w('#vectorImage1'),
                this.$w('#vectorImage2'),
                this.$w('#vectorImage3'),
            ];
        },
        enumerable: false,
        configurable: true
    });
    return SlotsListViewModel;
}());
export { SlotsListViewModel };
//# sourceMappingURL=slots-list.view-model.js.map